export default "__VITE_ASSET__7ret9chA__"